import classNames from 'classnames';
import { HtmlHTMLAttributes } from 'react';
import { Icon, IconButton } from 'rsuite';
import { ActionFeedbackDialog, PageLayout } from '../../../../../components';
import { ExcluirNegociacaoModal, FecharNegocioModalModal, ReabrirNegociacaoModalModal } from '../../components';
import { SalvarNegociacaoModal as EditNegociacaoModal } from '../../components/Modals';
import { TableFornecedor } from '../NegociacaoFornecedor/components';
import { DetalhesDaNegociacaoHeading, DetalhesDaNegociacaoTableHeading } from '../NegociacoesSalvas/components';
import { AdicionarVerbaEmMassaModal, ResumoDeEnvioModal, UploadProdutosArquivoModal } from './components';
import { useDetalhesDaNegociacao } from './DetalhesDaNegociacao.hooks';
import styles from './DetalhesDaNegociacao.module.scss';

export type DetalhesDaNegociacao = HtmlHTMLAttributes<HTMLDivElement> & {
  match: {
    params?: Record<string, unknown>;
  };
};

export const DetalhesDaNegociacao = ({ className }: DetalhesDaNegociacao) => {
  const { handleNavBack, table, heading, tableHeading, modals } = useDetalhesDaNegociacao();

  return (
    <>
      <PageLayout className={classNames(styles['detalhes-da-negociacao'], className)}>
        <PageLayout.Header className={styles['detalhes-da-negociacao__header']}>
          <div>
            <IconButton onClick={handleNavBack} icon={<Icon icon="back-arrow" />} />
            Voltar para negociações salvas
          </div>
          <p>As alterações são salvas automaticamente </p>
        </PageLayout.Header>
        <DetalhesDaNegociacaoHeading {...heading} />
        <DetalhesDaNegociacaoTableHeading {...tableHeading} />
        <TableFornecedor {...table} />
      </PageLayout>
      <>
        <ExcluirNegociacaoModal {...modals.excluirNegociacao} />
        <FecharNegocioModalModal {...modals.fecharNegocio} />
        <ReabrirNegociacaoModalModal {...modals.reabrirNegocio} />
        <EditNegociacaoModal {...modals.editarNegociacao} />
        <UploadProdutosArquivoModal {...modals.adicionarProdutosArquivo} />
        <ActionFeedbackDialog {...modals.feedbackUploadArquivo} />
        <ResumoDeEnvioModal {...modals.resumoDeEnvio} />
        {/* Sem grão declarado não há modal: a rota grava por uma estratégia diferente em cada grão. */}
        {modals.adicionarVerbaEmMassa ? <AdicionarVerbaEmMassaModal {...modals.adicionarVerbaEmMassa} /> : null}
      </>
    </>
  );
};
